// extracted by mini-css-extract-plugin
export default {"essayTitle":"suplementalessayforprofile_essayTitle__YpCNS","essayItem":"suplementalessayforprofile_essayItem__7jXoe"};